module.exports = __webpack_public_path__ + "img/103052.1bd47c48.png";